module.exports = __webpack_public_path__ + "fc884ff23195305d1749755d5930efa8.ico";